import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { components } from "react-select";
import "../../../../../styles/assets/images/icons/material/designSystem/AccessTime.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddLocation.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Business.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Calculate.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CoPresent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CopyAll.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FileCopy.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GridView.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Help.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HideSource.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/IosShare.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Link.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocationOn.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LockOpen.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LockReset.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Loop.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Paid.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Percent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Publish.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Receipt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../../styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Replay.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Restore.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Save.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Security.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Square.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/TableView.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Undo.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Update.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Videocam.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ViewList.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Visibility.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WiFi.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../../styles/assets/images/icons/brands/GoogleG.js";
import { sass } from "../../../../../sass/sass.js";
import FlashFormInputRichSelect from "../FlashFormInputRichSelect/FlashFormInputRichSelect.js";
import { u as useTranslation } from "../../../../../useTranslation-cf39c293.js";
import "react-dom";
import "../../../../atoms/popups/FlashModal/FlashModal.js";
import "../../../../../index-5e4e4f4b.js";
import "../../../../../axios-5f69b112.js";
import "../../../../../_commonjsHelpers-0c53d963.js";
import "../../../../../index-e71f83b5.js";
import "../../../../../utils-f8d1c624.js";
import "../../../../../Fade-1a465599.js";
import "../../../../../Transition-c07376a3.js";
import "../../../../constants.js";
import "../../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../../index-2d889c01.js";
import "../../../../../hooks/useInsights/useInsights.js";
import "../../../../../utils/noOp.js";
import "../../../../../hooks/useLogger/constants.js";
import "../../../../../hooks/useLogger/useLogger.js";
import "../../../../../hooks/useLogger/LoggerContext.js";
import "../../../../../hooks/useLogger/types.js";
import "../../../../../hooks/useInsights/InsightsContext.js";
import "../../../../../hooks/useInsights/utils.js";
import "../../../../../hooks/useWindowSize/useWindowSize.js";
import "../../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../../isObject-ec23ace2.js";
import "../../../../../isSymbol-c6f5cd95.js";
import "../../../../../i18n/index.js";
import "../../../../../i18n/translations/en.js";
import "../../../../../i18n/translations/es.js";
import "../../../../../i18nInstance-89725fcb.js";
import "../../../../atoms/buttons/FlashButton/FlashButton.js";
import "../../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../../Button-9f0631d3.js";
import "../../../../../utils/invokeFn.js";
import "../../../../atoms/buttons/FlashButton/constants.js";
import "../../../../atoms/popups/FlashModal/FlashModalUtils.js";
import "../../../../../keysIn-f10bd97a.js";
import "../../../../../_arrayLikeKeys-44b287e6.js";
import "../../../../../I18nextProvider-16dc4551.js";
import "../../../../atoms/popups/FlashModal/useFlashModal.js";
import "../../../../../useReactSelectFlashStyles-0a417fd5.js";
import "../../../../../_Uint8Array-806c1b52.js";
function FlashFormInputPhoneNumberCountryCodeSelect(props) {
  const { defaultCountryCode, selectedCountryCode, onCountryChange, countries, menuWidth, showOptionsInModal } = props;
  useEffect(
    () => {
      selectedCountryCode || onCountryChange(countries[defaultCountryCode]);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire on initial render
     */
    []
  );
  const customSelectStyles = usePhoneCountrySelectStyles({ countries, menuWidth, showOptionsInModal });
  return /* @__PURE__ */ jsx(TranslatedRichSelect, { ...props, customSelectStyles });
}
function TranslatedRichSelect(props) {
  const { id, countries, onCountryChange, disabled, selectedCountryCode, showOptionsInModal, customSelectStyles } = props, { t } = useTranslation(), title = t("PHONE_NUMBER_COUNTRY:MODAL_TITLE");
  return /* @__PURE__ */ jsx(
    FlashFormInputRichSelect,
    {
      id: `${id}-country-select`,
      items: Object.values(countries),
      makeOption: (item) => ({ label: item.name, value: item.countryCode, item }),
      onChange: (_, option) => {
        onCountryChange(option == null ? void 0 : option.item);
      },
      disabled,
      selectedValue: selectedCountryCode,
      showOptionsInModal,
      customSelectStyles,
      customModalProps: { Title: title }
    }
  );
}
function usePhoneCountrySelectStyles(options) {
  const { countries, menuWidth, showOptionsInModal } = options, styles = useMemo(
    () => ({
      control(base) {
        return {
          ...base,
          width: sass.spacing.flash[1e3],
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          boxShadow: "none",
          border: "none",
          borderRight: `1px solid ${sass.color.flash.semantic.border.neutral}`,
          "&:hover": {
            borderColor: sass.color.flash.semantic.border.neutral
          }
        };
      },
      menu(base) {
        return {
          ...base,
          width: showOptionsInModal ? void 0 : menuWidth ? `${menuWidth}px` : "400px"
        };
      },
      input(base, props) {
        return {
          ...base,
          height: props.hasValue ? 0 : void 0,
          width: props.hasValue ? 0 : void 0,
          padding: props.hasValue ? 0 : void 0,
          margin: props.hasValue ? 0 : void 0,
          caretColor: props.hasValue ? "transparent" : void 0,
          fontSize: "1px",
          color: "transparent"
        };
      }
    }),
    [menuWidth, showOptionsInModal]
  ), components$1 = useMemo(
    () => ({
      ValueContainer(props) {
        const selectedCountryCode = props.hasValue ? props.getValue()[0] : void 0, selectedCountry = selectedCountryCode != null && selectedCountryCode.value ? countries[selectedCountryCode.value] : void 0, children = props.children || [];
        return /* @__PURE__ */ jsxs(components.ValueContainer, { ...props, isDisabled: !0, children: [
          children[1],
          !selectedCountry && children[0],
          selectedCountry && /* @__PURE__ */ jsx("div", { className: "d-flex align-items-center", children: /* @__PURE__ */ jsx("span", { style: { width: "32px" }, children: /* @__PURE__ */ jsx(selectedCountry.Flag, {}) }) })
        ] });
      },
      Option(props) {
        const country = props.data.value ? countries[props.data.value] : void 0;
        return /* @__PURE__ */ jsx(components.Option, { ...props, children: country && /* @__PURE__ */ jsxs("div", { className: "d-flex justify-content-between py-flashd-113", children: [
          /* @__PURE__ */ jsxs("span", { className: "d-flex gap-flash-100 align-items-center", children: [
            /* @__PURE__ */ jsx("span", { style: { width: "28px" }, children: /* @__PURE__ */ jsx(country.Flag, {}) }),
            /* @__PURE__ */ jsx("span", { children: country.name })
          ] }),
          /* @__PURE__ */ jsx("span", { children: country.callingCode })
        ] }) });
      }
    }),
    [countries]
  );
  return { styles, components: components$1 };
}
export {
  FlashFormInputPhoneNumberCountryCodeSelect
};
//# sourceMappingURL=FlashFormInputPhoneNumberCountryCodeSelect.js.map
